import {ThemeColorName, ThemeType} from '../../../theme';
import {BaseInputProps, InputProps} from '../types';
import {InputStyleMap} from '../styles';

export const mapInputColorsToBaseProperties = (
  theme: ThemeType,
  props: InputProps,
): BaseInputProps => {
  const {state = 'Default', clear} = props;

  const inputStyle = InputStyleMap[state];
  const backgroundColor: ThemeColorName = clear
    ? 'transparent'
    : inputStyle.backgroundColor;
  const textColor = inputStyle.textColor;
  const placeholderColor = inputStyle.placeholderColor;
  const selectionColor = inputStyle.selectionColor;
  const selectionBackground = inputStyle.selectionBackgroundColor;

  return {
    textColor: theme.colors[textColor],
    placeholderColor: theme.colors[placeholderColor],
    selectionColor: theme.colors[selectionColor],
    selectionBackgroundColor: theme.colors[selectionBackground],
    backgroundColor: theme.colors[backgroundColor],
  };
};
